<script setup lang="ts">
withDefaults(defineProps<{
  as?: 'h1' | 'h2' | 'h3' | 'h4' | 'h5' | 'h6'
  align?: 'left' | 'center' | 'right'
}>(), {
  as: 'h2',
  align: 'left'
})
</script>

<template>
  <component :is="as" class="section-title" :class="`section-title-${align}`">
    <BlogTitleText><slot /></BlogTitleText>
  </component>
</template>

<style scoped>
.section-title {
  width: 100%;
  margin: 0;
  color: var(--text);
  font-size: 26px;
  text-align: left;
  scroll-margin-top: var(--anchor-offset);
}

.section-title-center {
  text-align: center;
}

.section-title-right {
  text-align: right;
}
</style>
